export const handleEnhanceNarrativeFactory = ({
  type,
  formName,
  components,
  sectionRef,
  clinicalNote,
  currentHpOverviewData,
  mappings = {},
  preferredMappings = {},
  overrides = {},
  extraBodyResolvers = [],
  setEnhanceNarrativeParams,
  customFormId = null
}) => {
  return async () => {
    const activeForm = formName || Object.values(components || {})?.[0]?.path;
    let name = mappings?.[activeForm] || activeForm;
    const preferredFormName = preferredMappings?.[name];

    if (name === 'goals') name = 'goals_narrative';

    let body =
      currentHpOverviewData?.[activeForm]?.response?.narrative ||
      sectionRef?.current?.formData?.[name]?.narrative ||
      sectionRef?.current?.formData?.[name] ||
      sectionRef?.current?.formData?.[activeForm];

    if (!body && type === 'progress') {
      body =
        sectionRef?.current?.formData?.epn?.[name]?.narrative ||
        sectionRef?.current?.formData?.epn?.[name];
    }

    if (!body && type === 'intake') {
      body = sectionRef?.current?.formData?.mha?.[name];
    }

    if (overrides?.[activeForm]) {
      body = overrides[activeForm]({ clinicalNote, sectionRef });
    }

    for (const resolver of extraBodyResolvers) {
      const resolved = await resolver({ activeForm, name });
      if (resolved) {
        body = resolved;
        break;
      }
    }

    setEnhanceNarrativeParams({
      kind: type,
      name,
      preferredFormName,
      body: String(body || '').replace(/[\u{0080}-\u{FFFF}]/gu, ''),
      customFormId
    });
  };
};
